import { defineComponent as t, openBlock as o, createBlock as n, unref as s, mergeProps as a, withCtx as p, renderSlot as u } from "vue";
import l from "./ghl-ui.es184.js";
const i = t({
  name: "UIInputGroupLabel",
  inheritAttrs: !1
}), f = t({
  ...i,
  props: {
    size: {
      type: String,
      default: "large"
    }
  },
  setup(r) {
    return (e, c) => (o(), n(s(l), a(e.$attrs, { size: r.size }), {
      default: p(() => [
        u(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["size"]));
  }
}), _ = f;
export {
  _ as default
};
